import { HttpResult } from 'widgets-for-react'
import { cmsPageUrl } from '../../../../../utils/cmsPageUrl'
import { transformImage } from '../../../sharepointPageApi/transformers/pageDataToPage'
import { LinkData } from '../../../sharepointPageApi/types/pageData'
import { RelatedContentFilter } from '../../blocksState'
import { NewsOrEvent } from './relatedContentBlockState'
import { SearchableDossier } from '../../../../../backendApi/generated'

export type NewsOrEventData = {
  EventDate: string | null
  ContentType: 'News pagina' | 'Agenda pagina'
  HeaderImage: LinkData
  HeaderTitle: string
  Path: string
  AbsolutePath: string
  TeaserDescription: string
  Dossier: SearchableDossier | undefined
}[]

export const transformNewsOrEventData = (data: NewsOrEventData): NewsOrEvent[] =>
  data.map((item) => ({
    title: item.HeaderTitle,
    intro: item.TeaserDescription,
    image: transformImage(item.HeaderImage),
    url: cmsPageUrl(item),
    eventDate: item.EventDate ? new Date(item.EventDate) : undefined,
    dossier: item.Dossier,
  }))

export const relatedContentBlockApi = async (filter: RelatedContentFilter): Promise<HttpResult<NewsOrEvent[]>> => {
  const res = await fetch(
    `/api/v1/pages/newsandevents/filter?${filter.source === 'department' ? `department=${filter.department}&` : ''}${
      filter.source === 'specialist' ? `specialist=${filter.specialist}&` : ''
    }${filter.source === 'tags' ? filter.tags.map((tagId) => `tags=${tagId}`).join('&') : ''}&pageSize=3`
  )

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: NewsOrEventData = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: transformNewsOrEventData(data),
  }
}
